import { styled as t } from "@mui/material";
import i from "../../temp-lib/assets/icons/icon-ronin.svg.js";
import l from "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import s from "../../temp-lib/components/share/next/Image.js";
import { useTranslation as a } from "react-i18next";
import { jsxs as m, jsx as p } from "react/jsx-runtime";
const c = t(l)`
  --background-color: #1473e9;
  border-radius: 4px;
  color: white;
  flex: 1;
  font-size: 16px;
  gap: 6px;
  height: 50px;
  margin-bottom: 20px;
  margin-left: auto;
  width: 100%;
  :hover {
    filter: brightness(0.9);
  }
`, f = t(s)`
  filter: grayscale(100%) brightness(3);
  width: 24px;
  height: 24px;
`, w = ({
  onClick: o,
  text: r,
  className: e
}) => {
  const {
    t: n
  } = a();
  return /* @__PURE__ */ m(c, {
    onClick: o,
    className: e,
    children: [/* @__PURE__ */ p(f, {
      src: i
    }), r || n("login.general.button.connect_wallet")]
  });
};
export {
  w as default
};
//# sourceMappingURL=ConnectWalletButton.js.map
